import React from 'react';
import styled from 'styled-components';
import { theme as UITheme } from 'affiny-ui/src/theme';
import rem from '../../../utils/rem';
import { Box, Flex, Text } from '../../primitives';
import CompatibilityReportGrid from '../../svgs/svgr/CompatibilityReportGrid';

type Props = {
  titleTopLeft: string;
  titleTopRight: string;
  titleBottomLeft: string;
  titleBottomRight: string;
  valueX: number;
  valueY: number;
  secondaryValueX?: number;
  secondaryValueY?: number;
  textValue?: string;
  textSecondaryValue?: string;
  gradient?: boolean;
};

export const DOT_SIZE = 28;
export const GRAPH_LABEL_FONT_SIZE = 10;
export const MATRIX_CHART_SIZE = 200;
const DOT_BORDER = 6;

const MatrixGrid = ({
  titleTopLeft,
  titleTopRight,
  titleBottomLeft,
  titleBottomRight,
  valueX,
  valueY,
  secondaryValueX,
  secondaryValueY,
  textValue,
  textSecondaryValue,
  gradient,
}: Props) => {
  const renderDot = (x: number, y: number, color: string, text?: string) => (
    <>
      <Box
        position="absolute"
        bottom={rem(x)}
        left={rem(y)}
        width={rem(DOT_SIZE + DOT_BORDER)}
        height={rem(DOT_SIZE + DOT_BORDER)}
        background={gradient ? UITheme.colors.gradient : undefined}
        backgroundColor={gradient ? undefined : color}
        opacity={0.5}
        borderRadius="50%"
      />
      <Flex
        justifyContent="center"
        alignItems="center"
        position="absolute"
        bottom={rem(x + DOT_BORDER / 2)}
        left={rem(y + DOT_BORDER / 2)}
        width={rem(DOT_SIZE)}
        height={rem(DOT_SIZE)}
        background={gradient ? UITheme.colors.gradient : undefined}
        backgroundColor={gradient ? undefined : color}
        borderRadius="50%"
      >
        {text && (
          <Text
            textTransform="uppercase"
            lineHeight={rem(9)}
            color="light"
            variant="small"
            textAlign="center"
            fontSize={rem(10)}
          >
            {text}
          </Text>
        )}
      </Flex>
    </>
  );

  return (
    <Box width={rem(MATRIX_CHART_SIZE)}>
      <Flex mb="xSmall">
        <GraphText>{titleTopLeft}</GraphText>
        <GraphText>{titleTopRight}</GraphText>
      </Flex>
      <Box position="relative" width="100%" height={rem(MATRIX_CHART_SIZE)}>
        <CompatibilityReportGrid
          width={MATRIX_CHART_SIZE}
          height={MATRIX_CHART_SIZE}
        />
        {renderDot(valueX, valueY, 'apricot', textValue)}
        {secondaryValueX &&
          secondaryValueY &&
          renderDot(
            secondaryValueX,
            secondaryValueY,
            'accent',
            textSecondaryValue
          )}
      </Box>
      <Flex>
        <GraphText>{titleBottomLeft}</GraphText>
        <GraphText>{titleBottomRight}</GraphText>
      </Flex>
    </Box>
  );
};

const GraphText = styled.p`
  width: 50%;
  padding: 0 ${rem(10)};
  margin: 0;
  text-align: center;
  font-size: ${rem(GRAPH_LABEL_FONT_SIZE)};
  color: ${({ theme }) => theme.colors.secondary};
`;

export default MatrixGrid;
